import { Button, Pagination } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'

const PaginationContainer = props => {
  // Build a fetch URL for a given page off whichever sibling link the API gave us
  // (next/previous). Using URLSearchParams keeps any active filter params intact and
  // avoids the malformed double-`?` a naive string concat would produce.
  const buildPageUrl = (url, page) => {
    const urlObj = new URL(url)
    urlObj.searchParams.set('page', page)
    return urlObj.toString()
  }

  // A list that keeps its page in the URL (spec: cars-list-filters-in-url) asks for a page NUMBER
  // and ignores the server's links; every other list keeps the `getData(url)` path above.
  const byNumber = typeof props.onPageChange === 'function'
  const goTo = page => {
    if (byNumber) return props.onPageChange(page)
    const url = props.meta.next || props.meta.previous
    return url && props.getData(buildPageUrl(url, page))
  }

  return (
    <div className="w-full">
      {props.meta && props.meta.results ? (
        <div
          className="flex justify-center items-center gap-10 w-full"
          style={{
            padding: '1rem 2rem',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <Button
            onClick={() =>
              byNumber ? goTo(props.meta.page - 1) : props.getData(props.meta.previous)
            }
            disabled={!props.meta.previous}
          >
            Previous
          </Button>

          <Pagination
            current={props.meta.page}
            total={props.meta.count}
            pageSize={props.meta.pageSize}
            showSizeChanger={false}
            onChange={goTo}
          />

          <Button
            onClick={() => (byNumber ? goTo(props.meta.page + 1) : props.getData(props.meta.next))}
            disabled={!props.meta.next}
          >
            Next
          </Button>
        </div>
      ) : null}
    </div>
  )
}

PaginationContainer.propTypes = {
  meta: PropTypes.shape({
    count: PropTypes.number,
    next: PropTypes.string | null,
    previous: PropTypes.string | null,
    results: PropTypes.number,
    page: PropTypes.number,
    pageSize: PropTypes.number
  }),
  getData: PropTypes.func,
  /** When given, paging asks for a page number instead of following the server's links. */
  onPageChange: PropTypes.func
}

export default PaginationContainer
